<div class="details-card-wrapper">
    <!-- heading -->
    <h2>specifications</h2>

    <div class="details-card">
        <div class="details-card-body">
            <ul class="specification-list">
                <!-- specification -->
                @for (specification of specificationsToShow(); track specification) {
                <li class="row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 mb-3 mb-sm-3 mb-md-0 mb-lg-0 mb-xl-0">
                        <h3>{{ specification.name }}</h3>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                        <p>{{ specification.details | notApplicable }}</p>
                    </div>
                </li>
                }
            </ul>

            <!-- read more section -->
            @if (hasMoreSpecifications()) {
            <div class="view-more-section d-flex flex-row justify-content-end">
                <div class="view-more-content">
                    @if (!isExpanded()) {
                    <span (click)="toggleViewMoreComments()" class="view-more">View More Specifications</span>
                    }

                    <!-- for View Less -->
                    @if (isExpanded()) {
                    <span (click)="toggleViewMoreComments()" class="view-more">View Less Specifications</span>
                    }
                </div>
            </div>
            }
        </div>
    </div>
</div>